export default __webpack_public_path__ + "static/media/icon_collect_status_remain_to_approve.d75c95a8.png";